import { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { AnimatePresence, motion } from "framer-motion";
import { Search } from "lucide-react";
import { ProductCard } from "./ProductCard";
import { SectionHead } from "./Reveal";
import { API, CATEGORIES, slug } from "../lib/store";

const Pills = ({ active, setActive }) => (
  <div className="flex flex-wrap gap-2">
    {CATEGORIES.map((c) => (
      <button key={c} onClick={() => setActive(c)} data-testid={`guna-category-tab-${slug(c)}`}
        className={`relative rounded-full px-5 py-2.5 text-sm transition-colors ${active === c ? "text-[#FFFFFF]" : "text-stone-700 hover:text-[#1C1917]"}`}>
        {active === c && <motion.span layoutId="pill" className="absolute inset-0 rounded-full bg-[#D62828]" transition={{ type: "spring", stiffness: 380, damping: 32 }} />}
        <span className="relative">{c}</span>
      </button>
    ))}
  </div>
);

export const Catalogue = ({ active, setActive }) => {
  const [products, setProducts] = useState([]);
  const [q, setQ] = useState("");
  const [state, setState] = useState("loading");

  useEffect(() => {
    axios.get(`${API}/products`)
      .then((r) => { setProducts(Array.isArray(r.data) ? r.data : []); setState("ok"); })
      .catch(() => setState("error"));
  }, []);

  const shown = useMemo(() => products.filter((p) =>
    (active === "All" || p.category === active) && `${p.name} ${p.note}`.toLowerCase().includes(q.toLowerCase())), [products, active, q]);

  return (
    <section id="catalogue" className="mx-auto max-w-[1400px] px-5 py-24 md:px-10 md:py-32">
      <SectionHead kicker="The catalogue" title={<>Pick it. <em className="text-[#D62828]">We'll bag it.</em></>}>
        <label className="flex w-full items-center gap-3 border-b border-black/20 pb-2 md:w-72">
          <Search className="h-4 w-4 text-stone-600" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search the shelves" data-testid="guna-search-input"
            className="w-full bg-transparent text-sm text-[#1C1917] placeholder:text-stone-500 focus:outline-none" />
        </label>
      </SectionHead>
      <Pills active={active} setActive={setActive} />
      {state === "error" && <p className="mt-10 text-stone-700" data-testid="guna-catalogue-error">The shelves are being restocked. Please try again shortly.</p>}
      {state === "ok" && shown.length === 0 && <p className="mt-10 text-stone-700" data-testid="guna-catalogue-empty">Nothing matches that search.</p>}
      <motion.div layout className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        <AnimatePresence>
          {shown.map((p) => <ProductCard key={p.sku} p={p} />)}
        </AnimatePresence>
      </motion.div>
    </section>
  );
};
